export default "__VITE_ASSET__DWIA2$PU__"